// ZEO-Nachtautopilot (04.11.2026): Morgen-Uebersicht des letzten Nachtlaufs -- dringend / Rueckfrage / vorbereitet / nicht bearbeitet.
// Nur Lesen; Klick oeffnet die Aufgabe mit ihrem Arbeitspaket (Autopilot-Karte). Nichts wird ausgefuehrt.
import { useEffect, useState } from 'react';
import { betreuungAPI } from '@/api/betreuungAPI';
import { NACHT_KATEGORIE, datum, nachtGrund, nachtKopf } from '@/lib/autopilotBefund';

export default function AutopilotNachtUebersicht({ onOpen }) {
  const [daten, setDaten] = useState(null);
  const [kat, setKat] = useState('dringend');
  useEffect(() => { betreuungAPI.autopilotNachtlauf().then(setDaten).catch(() => setDaten(null)); }, []);
  if (!daten) return null;
  const k = daten.kategorien || {};
  const liste = k[kat] || [];
  return (
    <div className="bg-white border rounded-xl p-3 space-y-2 text-sm" data-testid="nacht-uebersicht">
      <div className="font-medium">ZEO-Nachtautopilot – Arbeitspakete zur Prüfung (nur Vorschläge, nichts ausgeführt)</div>
      <div className="text-slate-600" data-testid="nacht-kopf">{nachtKopf(daten.lauf)}</div>
      {daten.lauf && (
        <div className="flex flex-wrap gap-2">
          {Object.entries(NACHT_KATEGORIE).map(([id, label]) => (
            <button key={id} onClick={() => setKat(id)} data-testid={`nacht-kat-${id}`}
              className={`px-2 py-1 rounded border ${kat === id ? 'bg-blue-600 text-white border-blue-600' : 'bg-slate-50'}`}>
              {label} ({(k[id] || []).length})
            </button>))}
        </div>)}
      {daten.lauf && (
        <div className="max-h-96 overflow-auto divide-y" data-testid={`nacht-liste-${kat}`}>
          {liste.length === 0 && <p className="text-slate-500 py-2">Keine Aufgaben in dieser Gruppe.</p>}
          {liste.map((x) => (
            <button key={x.aufgabe_id} className="w-full text-left py-1.5 hover:bg-blue-50" onClick={() => onOpen(x.aufgabe_id)} data-testid={`nacht-aufgabe-${x.aufgabe_id}`}>
              <span className="font-medium">{x.titel || x.aufgabe_id}</span>
              <span className="text-slate-500"> · {x.klient_name || '—'} · Frist {x.faellig_am ? datum(x.faellig_am) : '—'}</span>
              {x.grund && <span className="text-amber-700"> · {nachtGrund(x.grund)}</span>}
            </button>))}
        </div>)}
    </div>
  );
}
